import axiosInstance from './AxiosWrapper'
import { ENDPOINT_ADDITIONAL_SALES_AVAILABILITY } from './Endpoints'

export const getAdditionalSalesService = async () => {
  return await axiosInstance.get(ENDPOINT_ADDITIONAL_SALES_AVAILABILITY)
}

